import { UrlManager } from '@skapiec/lib-url-manager';
import { useSelector } from '@ecommerce/nest-ssr/common';
import { useCallback } from 'react';
import { SearchUrlManagerInterface } from 'modules/search/interfaces/search-url-manager.interface';

export const useSearchUrl = (): (data?: SearchUrlManagerInterface) => string => {
    const params = useSelector((state: { searchUrlParams: SearchUrlManagerInterface;}) => state.searchUrlParams);

    return useCallback((data?: SearchUrlManagerInterface): string => {
        return UrlManager.search.view({ ...params, ...data });
    }, [params]);
};
